<template>
  <div class="pan-dialog-overlay" v-if="show">
    <div
      class="pan-dialog box-shadow"
      :style="{
        backgroundColor: isDarkTheme && shadowBgColor ? shadowBgColor : '#ffffff'
      }"
    >
      <div class="pan-dialog-title text-uppercase">PAN Required</div>
      <div class="pan-dialog-subtitle">
        Please enter your PAN to continue
      </div>
      <input
        :style="{
          backgroundColor:
            isDarkTheme && offersCardBgColor ? offersCardBgColor : '#ffffff'
        }"
        class="margin-bottom-10 custom-input w80 fs-16 text-uppercase"
        type="text"
        v-model="pan"
        maxlength="10"
        placeholder="PAN"
      />
      <div class="pan-dialog-actions">
        <button
          class="custom-button small radius-5 text-uppercase pointer pan-cancel-btn"
          @click="close()"
        >
          cancel
        </button>
        <button
          class="custom-button small radius-5 text-uppercase pointer"
          :style="{
            background: isDarkTheme && buttonBGColor ? buttonBGColor : '#4a4a4a',
            color:
              isDarkTheme && headingTextColor ? headingTextColor : '#ffffff'
          }"
          style="padding: 10px 30px;"
          :disabled="loading"
          @click="submit()"
        >
          {{ loading ? "verifying..." : "submit" }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
export default {
  name: "PanDialog",
  mixins: [globals],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pan: "",
      loading: false
    };
  },
  methods: {
    close() {
      this.pan = "";
      this.loading = false;
      this.$emit("close");
    },
    submit() {
      var pan = this.pan ? this.pan.trim().toUpperCase() : "";
      if (!pan) {
        this.toastPopup(true, "Please enter your PAN");
        return false;
      }

      var url = this.$store.getters.flyyDomain + "/v1/tds/validate_pan";
      var headers = this.$store.getters.headers;

      this.loading = true;
      axios({
        method: "post",
        url: url,
        headers: headers,
        data: { pan: pan }
      })
        .then(resp => {
          this.loading = false;
          if (resp.status == 200 && resp.data.success) {
            if (resp.data.message) {
              this.toastPopup(true, resp.data.message);
            }
            this.pan = "";
            this.$emit("success");
          } else {
            this.toastPopup(
              true,
              resp.data.message ? resp.data.message : "Invalid PAN"
            );
          }
        })
        .catch(err => {
          this.loading = false;
          var message =
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : "PAN validation failed. Please try again.";
          this.toastPopup(true, message);
        });
    }
  },
  computed: {
    isDarkTheme() {
      return this.$store.state.sdkEvent && this.$store.state.sdkEvent.isDarkTheme
        ? this.$store.state.sdkEvent.isDarkTheme
        : null;
    },
    themeColors() {
      return this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors
        ? this.$store.state.sdkEvent.themeColors
        : {};
    },
    shadowBgColor() {
      return this.themeColors.shadowBgColor || null;
    },
    offersCardBgColor() {
      return this.themeColors.offersCardBgColor || null;
    },
    buttonBGColor() {
      return this.themeColors.buttonBGColor || null;
    },
    headingTextColor() {
      return this.themeColors.headingTextColor || null;
    }
  }
};
</script>
<style>
.pan-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pan-dialog {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  width: 80%;
  max-width: 320px;
  text-align: center;
  color: black;
}
.pan-dialog-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
}
.pan-dialog-subtitle {
  font-size: 13px;
  color: #9f9f9f;
  margin-bottom: 15px;
}
.pan-dialog-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
}
.pan-cancel-btn {
  background: transparent;
  color: #9f9f9f;
  padding: 10px 20px;
}
</style>
